import React, {useCallback, useEffect, useRef, useState} from "react";
import ajaxloader from "../../images/ajax-loader.gif";
import ReviewService from "../../services/ReviewService";
import {BoxArrowUpRight, CheckSquareFill, Folder, Square, Upload} from "react-bootstrap-icons";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import {useDispatch} from "react-redux";
import {SecuredDownloadLink} from "../canopia/SecuredDownloadLink";
import {PageSelector} from "../core/PageSelector";
import {FormGroup} from "react-bootstrap";
import {IconContext} from "react-icons";
import {TiDeleteOutline} from "react-icons/ti";
import NameTruncWithSearch from "../canopia/NameTruncWithSearch";
import HSort from "../canopia/HSort";
import {
    CONTAINS,
    emptyOnly,
    inList,
    isNotEmpty,
    REVIEW_API_URL,
    search2,
    sort,
    STARTS_WITH
} from "../canopia/CanopiaUtils";
import FlatMultiSelect, {ALL} from "../canopia/FlatMultiSelect";
import Btn from "../canopia/Btn";

export default function ReviewStatus(props) {

    const dispatch = useDispatch();

    const PAGE_SIZE = 50;
    const FINAL_PUBLICATION_ACTION = 'publish/final';
    const ESG_CHECK_ACTION = 'publish/esg-check';
    const GLOBAL_REPORT_ACTION = 'publish/global-report';

    // Filter
    // let curYear = new Date().getFullYear();
    const [selectedYears, setSelectedYears] = useState([]);
    const [yearEnum, setYearEnum] = useState([]);
    const [selectedMonths, setSelectedMonths] = useState([]);
    const [monthEnum, setMonthEnum] = useState([]);
    const [yearToMonth, setYearToMonth] = useState({});

    // Form
    const [showActionModal, setShowActionModal] = useState(false);
    const [ignoreDiff, setIgnoreDiff] = useState(false);
    const [tgtAction, setTgtAction] = useState(null);
    const [tgtClientId, setTgtClientId] = useState(null);
    const [tgtClientName, setTgtClientName] = useState(null);
    const [tgtDate, setTgtDate] = useState(null);
    const [files, setFiles] = useState(null);
    const inputFiles = useRef(null);
    const [fileNames, setFileNames] = useState([]);
    const [folder, setFolder] = useState(null);
    const [actionRequestStatus, setActionRequestStatus] = useState('idle');
    const [messages, setMessages] = useState(null);
    const [actionErrorMessage, setActionErrorMessage] = useState(null);

    const [tgtDataOrig, setTgtDataOrig] = useState([]);
    const [loadingStatus, setLoadingStatus] = useState('idle');

    // pagination
    const [page, setPage] = useState(1);

    // search
    const [clearSearchVisibility, setClearSearchVisibility] = useState('hidden');
    const [searchString, setSearchString] = useState('');
    const [showRevised, setShowRevised] = useState(true);
    const [showNotRevised, setShowNotRevised] = useState(true);

    const initialSortStatus = {
        "client.displayName": "asc",
        "client.id": "asc",

        "job.job1DateFmt": "asc",
        "job.job1CreateTimestampFmt": "desc",
        "job.job1ConsensusIdInt": "asc",
        "job.job1User": "asc",
        "job.job1Duration": "asc",
        "job.job1ReportPublicationTimestampFmt": "asc",
        "job.job1PublicationTimestampFmt": "asc",

        "job.job2CreateTimestampFmt": "asc",
        "job.job2ConsensusIdInt": "asc",
        "job.job2User": "asc",
        "job.job2Duration": "asc",
    }

    const SEARCH_PROPS = [
        'client.displayName',
        'client.id',
        'job.job1DateFmt',
        'job.job1ConsensusIdInt',
        'job.job1User',
        'job.job2ConsensusIdInt',
        'job.job2User'];

    const sortAndFilterInitialState = {
        sortStatus: initialSortStatus,
        sortCol: "job.job1CreateTimestampFmt",
    }

    const [myState, setMyState] = useState(null);

    const borderLeft = 'border-left';

    const sizes = [75, 95, 110, 122, 250, 54];

    const padding = '0.55em 0.5em';

    const load = useCallback(() => {
        setTgtDataOrig([]);
        setLoadingStatus('loading');
        ReviewService.loadAllJobs()
            .then(response => {
                    const respData = response.data;
                    if (respData) {
                        setLoadingStatus('success');
                        let jobs = respData.data;
                        setTgtDataOrig(jobs);
                        let years = [];
                        let tgtYearEnum = [];
                        const tgtYearToMonth = {};
                        if (jobs && jobs.length > 0) {
                            jobs.forEach(job => {
                                let date = job.job.job1DateFmt;
                                if (date) {
                                    let year = date.substring(0, 4);
                                    if (!years.includes(year)) {
                                        years.push(year);
                                        tgtYearEnum.push({key: year, label: year});
                                        tgtYearToMonth[year] = [];
                                    }
                                    let month = date.substring(5, 7);
                                    if (!tgtYearToMonth[year].includes(month)) {
                                        tgtYearToMonth[year].push(month);
                                    }
                                }
                            });
                        }
                        tgtYearEnum.sort((a, b) => -(a.key - b.key));
                        setYearEnum(tgtYearEnum);
                        let tgtSelYears = [];
                        let tgtSelMonths = [];
                        if (tgtYearEnum.length > 0) {
                            let tgtYearOpt = tgtYearEnum[0];
                            tgtSelYears = [tgtYearOpt];
                            setSelectedYears(tgtSelYears);
                            let months = tgtYearToMonth[tgtYearOpt.key];
                            let tgtSelMonths = months.map(m => {
                                return {key: m, label: m}
                            });
                            tgtSelMonths.sort((a, b) => -(a.key - b.key));
                            setMonthEnum(tgtSelMonths);
                            setSelectedMonths(tgtSelMonths);
                        }
                        setYearToMonth(tgtYearToMonth);
                        filter(tgtSelYears, tgtSelMonths, showRevised, showNotRevised, "", jobs, tgtYearEnum, tgtSelMonths);
                    } else {
                        setLoadingStatus('error');
                        setMessages(null);
                    }
                },
                error => {
                    setLoadingStatus('error');
                });
    }, [dispatch]);

    useEffect(() => {
        if (loadingStatus === 'idle') {
            load();
        }
    }, [loadingStatus, load]);

    function changeSelectedYears(tgtElem) {
        let tgtSelection;

        if (tgtElem === ALL) {
            if (selectedYears.length < yearEnum.length) {
                tgtSelection = [...yearEnum];
            } else {
                tgtSelection = [yearEnum[0]];
            }
        } else {
            tgtSelection = [...selectedYears];
            let indexOf = selectedYears.findIndex(elem => tgtElem.key === elem.key);
            if (indexOf > -1) {
                if (selectedYears.length <= 1) {
                    // Cannot unselect the last one
                    return;
                }
                tgtSelection.splice(indexOf, 1);
            } else {
                tgtSelection.push(tgtElem);
            }
        }

        let allMonths = [];
        tgtSelection.forEach(elem => {
            let months = yearToMonth[elem.key];
            months.forEach(m => {
                if (!allMonths.includes(m)) {
                    allMonths.push(m);
                }
            })
        });
        let tgtMonthEnum = allMonths.map(m => {
            return {key: m, label: m}
        });
        tgtMonthEnum.sort((a, b) => -(a.key - b.key));
        let tgtMonthOpt = tgtMonthEnum[0];
        let tgtSelMonths = [tgtMonthOpt];
        setMonthEnum(tgtMonthEnum);
        setSelectedMonths(tgtSelMonths);

        setSelectedYears(tgtSelection);
        filter(tgtSelection, tgtSelMonths, showRevised, showNotRevised, searchString, tgtDataOrig, yearEnum, monthEnum);
    }

    function changeSelectedMonths(tgtElem) {
        let tgtSelection;

        if (tgtElem === ALL) {
            if (selectedMonths.length < monthEnum.length) {
                tgtSelection = [...monthEnum];
            } else {
                tgtSelection = [];
            }
        } else {
            tgtSelection = [...selectedMonths];
            let indexOf = selectedMonths.findIndex(elem => tgtElem.key === elem.key);
            if (indexOf > -1) {
                if (selectedMonths.length <= 1) {
                    // Cannot unselect the last one
                    return;
                }
                tgtSelection.splice(indexOf, 1);
            } else {
                tgtSelection.push(tgtElem);
            }
        }

        setSelectedMonths(tgtSelection);
        filter(selectedYears, tgtSelection, showRevised, showNotRevised, searchString, tgtDataOrig, yearEnum, monthEnum);
    }

    function showModal(action, clientId, date, clientName, fileNames, folder) {
        setShowActionModal(true);
        setTgtClientId(clientId);
        setTgtDate(date);
        setTgtAction(action);
        setTgtClientName(clientName);
        setFolder(folder);
        setFileNames(fileNames);
    }

    function hideActionModal() {
        setTgtClientId(null);
        setTgtClientName(null);
        setTgtDate(null);
        setMessages(null);
        setFiles(null);
        setActionErrorMessage(null);
        setShowActionModal(false);
        if (inputFiles.current) {
            inputFiles.current.value = "";
            inputFiles.current.type = "file";
        }
    }

    function callAction() {
        setActionRequestStatus('pending');

        if ([GLOBAL_REPORT_ACTION, ESG_CHECK_ACTION].includes(tgtAction)) {
            ReviewService.importReport(files, tgtClientId, tgtDate, tgtAction, ignoreDiff)
                .then(response => {
                    setActionRequestStatus('success');

                    const respData = response.data;
                    if (respData) {
                        const messages = respData.data;
                        setMessages(messages);
                        if (!messages.some(message => message.key.toLowerCase() === 'error')) {
                            load(); // triggers a refresh of the page
                        }
                    } else {
                        setMessages(null);
                    }
                }, error => {
                    setActionRequestStatus('error');
                    const resMessage = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();

                    setActionErrorMessage(resMessage);
                });
        } else {

            ReviewService.call(tgtAction, tgtClientId, tgtDate) //
                .then(response => {
                    setActionRequestStatus('success');
                    setMessages(response.data ? response.data.data : null);
                    if ([FINAL_PUBLICATION_ACTION].includes(tgtAction)) {
                        load(); // triggers a refresh of the page
                    }
                }, error => {
                    setActionRequestStatus('error');
                    const resMessage = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();

                    setActionErrorMessage(resMessage);
                });
        }
    }

    const onFileChange = (event) => {
        setFiles(event.target.files);
    }

    const onChangeIgnoreDiff = () => {
        setIgnoreDiff(!ignoreDiff);
    }

    function sortFunc(colName) {
        const newState = sort({...myState}, colName, initialSortStatus);
        setMyState(newState);
    }

    function changePage(page) {
        setPage(page.key);
    }

    // Search category, the component is common to the global and histo view
    const searchCategory = (e) => {
        let searchString = e.target.value;
        searchCat(searchString);
    }

    const resetSearch = () => {
        searchCat('');
    }

    function searchCat(searchString) {
        setSearchString(searchString);
        filter(selectedYears, selectedMonths, showRevised, showNotRevised, searchString, tgtDataOrig, yearEnum, monthEnum);
    }

    function handleShowRevised(show) {
        if (!show && !showNotRevised) {
            // Empty selection -> forbid
            return;
        }
        filter(selectedYears, selectedMonths, show, showNotRevised, searchString, tgtDataOrig, yearEnum, monthEnum);
        setShowRevised(show);
    }

    function handleShowNotRevised(show) {
        if (!show && !showRevised) {
            // Empty selection -> forbid
            return;
        }
        filter(selectedYears, selectedMonths, showRevised, show, searchString, tgtDataOrig, yearEnum, monthEnum);
        setShowNotRevised(show);
    }

    function filter(selectedYears, selectedMonths, showRevised, showNotRevised, searchString, list, yearEnum, monthEnum) {
        let newData = [...list];

        // Year filter
        if (selectedYears.length < yearEnum.length) {
            newData = inList(selectedYears.map(option => option.key), newData, ["job.job1DateFmt"], STARTS_WITH);
        }

        // Month filter
        if (selectedMonths.length < monthEnum.length) {
            newData = inList(selectedMonths.map(option => '-' + option.key + '-'), newData, ["job.job1DateFmt"], CONTAINS);
        }

        // Revised filter
        if (showRevised && !showNotRevised) {
            newData = isNotEmpty(newData, ["job.job2CreateTimestampFmt"]);
        } else if (!showRevised && showNotRevised) {
            newData = emptyOnly(newData, ["job.job2CreateTimestampFmt"]);
        }

        // Search filter
        if (searchString.trim() === "") {
            setClearSearchVisibility("hidden");
        } else {
            if (clearSearchVisibility === "hidden") {
                setClearSearchVisibility("visible");
            }
            newData = search2(searchString, newData, SEARCH_PROPS);
        }

        let newState;
        if (myState) {
            newState = {...myState, tgtData: newData};
        } else {
            newState = {...sortAndFilterInitialState, tgtData: newData};
        }

        newState = sort(newState, newState.sortCol, initialSortStatus, true);

        setMyState(newState);
    }

    let searchCategoryInput = <FormGroup controlId="selectView">
        <input value={searchString}
               placeholder="Search client, date, consensus, user..."
               className={'form-control float-left'}
               style={{minWidth: "300px"}}
               aria-label="Search category"
               onChange={searchCategory}
               aria-describedby="basic-addon2"/>
    </FormGroup>;

    let searchCategoryComp;
    const isIE = /*@cc_on!@*/false || !!document.documentMode;
    if (isIE) {
        searchCategoryComp =
            <div style={{display: "flex", flexWrap: "nowrap", marginRight: 'auto'}}>
                {searchCategoryInput}
            </div>
    } else {
        searchCategoryComp = <div style={{display: "flex", flexWrap: "nowrap"}}>
            {searchCategoryInput}
            <Button variant="light" size="sm"
                    style={{
                        marginLeft: 0,
                        padding: 4,
                        borderWidth: '1px 1px 1px 0',
                        borderColor: '#ced4da',
                        borderRadius: '0.25rem .25rem .25rem 0.25rem',
                        visibility: clearSearchVisibility
                    }}
                    onClick={resetSearch}>
                <IconContext.Provider value={{className: "react-icons canopia2", size: "1.4em"}}>
                    <TiDeleteOutline/>
                </IconContext.Provider>
            </Button>
            {/*<span style={{paddingLeft: '10px', margin: 'auto'}}>{searchString.length > 0 ? searchCount + ' result(s)' : ''}</span>*/}
        </div>
    }

    let content;
    switch (loadingStatus) {
        case 'loading':
            content = <div><br/><img alt="loading" src={ajaxloader}/></div>;
            break;
        case 'error':
            content = <div className="dashboard">
                <header className="jumbotron">
                    <h3 className='canopia'>Error</h3>
                </header>
            </div>
            break;
        case 'success':
            const colorClass = 'canopia2';

            let rows;
            let effPage = page;
            let tgtData = myState.tgtData;
            if (tgtData) {

                let startIndex = (effPage - 1) * PAGE_SIZE;
                if (startIndex >= tgtData.length) {
                    effPage = 1;
                    startIndex = (effPage - 1) * PAGE_SIZE;
                }
                const tgtDataAtPage = tgtData.slice(startIndex, startIndex + PAGE_SIZE);

                // Create the DOM objects
                rows = tgtDataAtPage.map(elem => {
                    return <div key={elem.client.id + '_' + elem.job.job1DateFmt} className={"flex-nowrap border-top"}>
                        <div className={"setup-col"} style={{flexBasis: sizes[4] + 'px', padding: padding}}>
                            <NameTruncWithSearch name={elem.client.displayName} maxSize={80} search={searchString}
                                                 wrap={true}/>
                        </div>
                        <div className={"setup-col"} style={{flexBasis: sizes[5] + 'px', padding: padding}}>
                            <NameTruncWithSearch name={elem.client.id} maxSize={12} search={searchString} wrap={true}/>
                        </div>
                        <div className={"setup-col nowrap"} style={{flexBasis: sizes[1] + 'px', padding: padding}}>
                            <NameTruncWithSearch name={elem.job.job1DateFmt} maxSize={12} search={searchString}
                                                 wrap={true}/>
                        </div>

                        {/* Initial */}
                        <div className={"setup-col " + borderLeft}
                             style={{flexBasis: sizes[2] + 'px', padding: padding}}>
                            {elem.job.job1CreateTimestampFmt}
                        </div>
                        <div className={"setup-col"} style={{flexBasis: sizes[0] + 'px', padding: padding}}>
                            <NameTruncWithSearch name={elem.job.job1ConsensusIdInt} maxSize={12} search={searchString}
                                                 wrap={true}/>
                        </div>
                        <div className={"setup-col"} style={{flexBasis: sizes[1] + 'px', padding: padding}}>
                            <NameTruncWithSearch name={elem.job.job1User} maxSize={40} search={searchString}
                                                 wrap={true}/>
                        </div>
                        <div className={"setup-col nowrap"} style={{flexBasis: sizes[1] + 'px', padding: padding}}>
                            {elem.job.job1Duration}
                        </div>

                        {/* Review */}
                        <div className={"setup-col " + borderLeft}
                             style={{flexBasis: sizes[2] + 'px', padding: padding}}>
                            {elem.job.job2CreateTimestampFmt}
                        </div>
                        <div className={"setup-col"} style={{flexBasis: sizes[0] + 'px', padding: padding}}>
                            <NameTruncWithSearch name={elem.job.job2ConsensusIdInt} maxSize={12} search={searchString}
                                                 wrap={true}/>
                        </div>
                        <div className={"setup-col"} style={{flexBasis: sizes[1] + 'px', padding: padding}}>
                            <NameTruncWithSearch name={elem.job.job2User} maxSize={40} search={searchString}
                                                 wrap={true}/>
                        </div>
                        <div className={"setup-col nowrap"} style={{flexBasis: sizes[1] + 'px', padding: padding}}>
                            {elem.job.job2Duration}
                        </div>

                        {/* Reports */}
                        <div className={"setup-col " + borderLeft}
                             style={{flexBasis: sizes[2] + 'px', padding: padding}}>
                            {elem.job.job1ReportPublicationStatus === 1 ? elem.job.job1ReportPublicationTimestampFmt :
                                <span className={'label-hover'}
                                      onClick={() => showModal(ESG_CHECK_ACTION, elem.client.id, elem.job.job1DateFmt, elem.client.displayName)}>
                                    <Upload color={'#adad2f'} size={'1.3em'}/>
                                </span>}
                        </div>
                        <div className={"setup-col " + borderLeft}
                             style={{flexBasis: sizes[3] + 'px', padding: padding}}>
                            {elem.job.job1GlobalReportPublicationStatus === 1 ? elem.job.job1GlobalReportPublicationTimestampFmt :
                                <span className={'label-hover'}
                                      onClick={() => showModal(GLOBAL_REPORT_ACTION, elem.client.id, elem.job.job1DateFmt, elem.client.displayName)}>
                                    <Upload color={'#adad2f'} size={'1.3em'}/>
                                </span>}
                        </div>
                        <div className={"setup-col " + borderLeft}
                             style={{flexBasis: sizes[2] + 'px', padding: padding}}>
                            {elem.job.job1PublicationStatus === 1 ? elem.job.job1PublicationTimestampFmt :
                                <span className={'label-hover'}
                                      onClick={() => showModal(FINAL_PUBLICATION_ACTION, elem.client.id, elem.job.job1DateFmt, elem.client.displayName)}>
                                    <BoxArrowUpRight color={'#adad2f'} size={'1.3em'}/>
                                </span>}
                        </div>
                        <div className={"setup-col " + borderLeft}
                             style={{flexBasis: sizes[0] + 'px', padding: padding}}>
                            {elem.filesByDir.hasOwnProperty("ROOT") &&
                                <span className={'label-hover'}
                                      onClick={() => showModal('review-folder',
                                          elem.client.id,
                                          elem.job.job1DateFmt,
                                          elem.client.displayName,
                                          elem.filesByDir["ROOT"])}>
                                    <Folder color={'#adad2f'} size={'1.4em'}/>
                                </span>
                            }
                        </div>
                        <div className={"setup-col " + borderLeft}
                             style={{flexBasis: sizes[0] + 'px', padding: padding}}>
                            <SecuredDownloadLink clientId={elem.client.id} fileName={elem.client.name + '_History'}
                                                 method='csv'/>
                        </div>
                    </div>;
                });
            }
            const pageSelector = <PageSelector page={effPage} pageSize={PAGE_SIZE} size={tgtData.length}
                                               clickFunc={changePage}/>;

            const params = <div className={'canopia2'} style={{fontSize: "x-large"}}>{tgtClientName}, {tgtDate}</div>
            let modalText = <></>;
            switch (tgtAction) {
                // case 'create-diff':
                //     modalText = <>
                //         <p className={'canopia2'} style={{fontSize: "x-large"}}>Diff files</p>
                //         <p>Create the diff file(s) between Conser and Canopia analysis files</p>
                //         <p>The diff files will be saved in the same directory than the analysis files.</p>
                //     </>;
                //     break;
                case FINAL_PUBLICATION_ACTION:
                    modalText = <>
                        <p className={'canopia2'} style={{fontSize: "large"}}>Final Publication</p>
                        <p>Are you sure you want to publish that evaluation and made it available to all the users
                            having
                            access to this client?</p>
                        <p>The application cache will be reloaded accordingly.</p>
                    </>;
                    break;
                case ESG_CHECK_ACTION:
                    modalText = <>
                        <p className={'canopia2'} style={{fontSize: "large"}}>Publish ESG Checks</p>
                        <p className={'canopia'}>ZIP File</p>
                        <p>Select a ZIP file to upload and publish the ESG checks to the target client and date</p>
                        <p>NB: Existing files (same name) will be overridden</p>
                        <div className="form-group">
                            <input type="file"
                                   className={'form-control'}
                                   aria-label="Report File"
                                   onChange={onFileChange}
                                   aria-describedby="basic-addon2"
                                   ref={inputFiles}
                                   multiple
                            />
                        </div>
                        <p className={'canopia'} style={{marginTop: '1rem'}}>Ignore difference(s)</p>
                        <p style={{marginTop: '1rem'}}>If checked the ESG checks are published even if there are some
                            differences between the files and
                            Canopia data</p>
                        <p>NB: it is recommended to leave it unchecked to see the difference(s) first, then check it to
                            publish the files
                        </p>
                        <p>
                        <span onClick={onChangeIgnoreDiff} style={{marginRight: '3vw'}}>
                            <span>
                                {ignoreDiff ? <CheckSquareFill color={'#adad2f'} size={'1.4em'}/> :
                                    <Square color={'#adad2f'} size={'1.4em'}/>}
                            </span>
                        </span>
                        </p>
                    </>;
                    break;
                case GLOBAL_REPORT_ACTION:
                    modalText = <>
                        <p className={'canopia2'} style={{fontSize: "large"}}>Publish Global Reports</p>
                        <p className={'canopia'}>Report file(s)</p>
                        <p>Please select report files to upload and publish to the target client and date</p>
                        <p>NB: Existing file (same name) will be overridden</p>
                        <div className="form-group">
                            <input type="file"
                                   className={'form-control'}
                                   aria-label="Report File"
                                   onChange={onFileChange}
                                   aria-describedby="basic-addon2"
                                   ref={inputFiles}
                                   multiple/>
                        </div>
                    </>;
                    break;
                case 'review-folder':
                    modalText = <>
                        <div style={{display: "flex", flexWrap: "nowrap"}} className={'dnl-row'}>
                            <div style={{padding: '.5rem 0', flex: "0 0 40px"}}>

                            </div>
                            <div style={{padding: '.5rem 0', flex: "0 0 500px", marginRight: '1rem'}}>Name</div>
                            <div style={{padding: '.5rem 0', flex: "0 0 150px", marginRight: '1rem'}}>Last update</div>
                        </div>
                        {fileNames.map(fileName => {
                            return <div style={{display: "flex", flexWrap: "nowrap"}} className={'dnl-row'}>
                                <div style={{padding: '.5rem 0', flex: "0 0 40px"}}>
                                    <SecuredDownloadLink clientId={tgtClientId} date={tgtDate}
                                                         category={folder} fileName={fileName.key} method='any'
                                                         apiUrl={REVIEW_API_URL}/>
                                </div>
                                <div style={{
                                    padding: '.5rem 0',
                                    flex: "0 0 500px",
                                    marginRight: '1rem'
                                }}>{fileName.key}</div>
                                <div style={{
                                    padding: '.5rem 0',
                                    flex: "0 0 150px",
                                    marginRight: '1rem'
                                }}>{fileName.value}</div>
                            </div>;
                        })}
                    </>;
                    break;
                case 'download-history':
                    modalText = <>
                        <p className={'canopia2'} style={{fontSize: "x-large"}}>Download history</p>
                        <p>Download a csv file containing the full history of this client?</p>
                    </>;
                    break;
                default:
                //
            }

            content = <>
                <div className={'sticky-div'}>
                    <div className={'border-top background-light ' + colorClass} style={{marginTop: "90px"}}>
                        <div className={"flex-nowrap"}>
                            <div className={"setup-th-input"}
                                 style={{flexBasis: (sizes[4] + sizes[1] + sizes[5]) + 'px'}}>
                                <div>{searchCategoryComp}</div>
                            </div>
                            <div className={"setup-th"} style={{flexBasis: sizes[4]}}>
                                <div className={"flex-wrap"}>
                                    <div>
                                        <FlatMultiSelect enums={yearEnum}
                                                         curValues={selectedYears}
                                                         curClass={'canopia-nav-btn-active'}
                                                         otherClass={'canopia-nav-btn'}
                                                         clickFunction={changeSelectedYears}
                                                         clickParamFromEnum={true}
                                                         useAll={true}
                                                         doNotTranslate={true}/>
                                    </div>
                                    <div style={{margin: '10px 0 0 0'}}>
                                        <FlatMultiSelect enums={monthEnum}
                                                         curValues={selectedMonths}
                                                         curClass={'canopia-nav-btn-active'}
                                                         otherClass={'canopia-nav-btn'}
                                                         clickFunction={changeSelectedMonths}
                                                         clickParamFromEnum={true}
                                                         useAll={true}
                                                         doNotTranslate={true}/>
                                    </div>
                                </div>
                            </div>
                            <div className={"setup-th"}>
                                <Btn label={'Revised'}
                                     curClass={showRevised ? 'canopia-nav-btn-active' : 'canopia-nav-btn'}
                                     clickFunction={handleShowRevised}
                                     btnValue={showRevised}
                                     doNotTranslate={true}/>
                                <Btn label={'Not Revised'}
                                     curClass={showNotRevised ? 'canopia-nav-btn-active' : 'canopia-nav-btn'}
                                     clickFunction={handleShowNotRevised}
                                     btnValue={showNotRevised}
                                     doNotTranslate={true}/>
                            </div>
                        </div>
                    </div>
                    <div className={'border-top background-light ' + colorClass}>
                        <div className={"flex-nowrap"}>
                            <div className={"setup-th"} style={{flexBasis: (sizes[4] + sizes[1] + sizes[5]) + "px"}}>
                                {pageSelector}
                            </div>
                            <div className={"setup-th " + borderLeft}
                                 style={{flexBasis: (2 * sizes[1] + sizes[2] + sizes[0]) + "px"}}>
                                1. Initial
                            </div>
                            <div className={"setup-th " + borderLeft}
                                 style={{flexBasis: (2 * sizes[1] + sizes[2] + sizes[0]) + "px"}}>
                                2. Review
                            </div>
                            <div className={"setup-th " + borderLeft} style={{flexBasis: (sizes[2] + sizes[3]) + "px"}}>
                                3. Reports
                            </div>
                            <div className={"setup-th " + borderLeft} style={{flexBasis: (sizes[2]) + "px"}}>
                                4. Client
                            </div>
                            <div className={"setup-th " + borderLeft}
                                 style={{flexBasis: (sizes[0] + sizes[0]) + "px"}}>
                                Download
                            </div>
                        </div>
                    </div>
                    <div className={'border-top background-light ' + colorClass}>
                        <div className={"flex-nowrap"}>
                            <div className={"setup-th"} style={{flexBasis: sizes[4] + 'px'}}>
                                <HSort label={<b>Client</b>} colName={'client.displayName'} state={myState}
                                       sortFunc={sortFunc}/>
                            </div>
                            <div className={"setup-th"} style={{flexBasis: sizes[5] + 'px'}}>
                                <HSort label={<b>ID</b>} colName={'client.id'} state={myState} sortFunc={sortFunc}/>
                            </div>
                            <div className={"setup-th"} style={{flexBasis: sizes[1] + 'px'}}>
                                <HSort label={<b>Pf Date</b>} colName="job.job1DateFmt" state={myState}
                                       sortFunc={sortFunc}/>
                            </div>

                            {/* Initial */}
                            <div className={"setup-th " + borderLeft} style={{flexBasis: sizes[2] + 'px'}}>
                                <HSort label={<b>Completed</b>} colName={'job.job1CreateTimestampFmt'} state={myState}
                                       sortFunc={sortFunc}/>
                            </div>
                            <div className={"setup-th"} style={{flexBasis: sizes[0] + 'px'}}>
                                <HSort label={<b>Cons.</b>} colName={'job.job1ConsensusIdInt'} state={myState}
                                       sortFunc={sortFunc}/>
                            </div>
                            <div className={"setup-th"} style={{flexBasis: sizes[1] + 'px'}}>
                                <HSort label={<b>User</b>} colName={'job.job1User'} state={myState}
                                       sortFunc={sortFunc}/>
                            </div>
                            <div className={"setup-th"} style={{flexBasis: sizes[1] + 'px'}}>
                                <HSort label={<b>Duration</b>} colName={'job.job1Duration'} state={myState}
                                       sortFunc={sortFunc}/>
                            </div>

                            {/* Review */}
                            <div className={"setup-th " + borderLeft} style={{flexBasis: sizes[2] + 'px'}}>
                                <HSort label={<b>Completed</b>} colName={'job.job2CreateTimestampFmt'} state={myState}
                                       sortFunc={sortFunc}/>
                            </div>
                            <div className={"setup-th"} style={{flexBasis: sizes[0] + 'px'}}>
                                <HSort label={<b>Cons.</b>} colName={'job.job2ConsensusIdInt'} state={myState}
                                       sortFunc={sortFunc}/>
                            </div>
                            <div className={"setup-th"} style={{flexBasis: sizes[1] + 'px'}}>
                                <HSort label={<b>User</b>} colName={'job.job2User'} state={myState}
                                       sortFunc={sortFunc}/>
                            </div>
                            <div className={"setup-th"} style={{flexBasis: sizes[1] + 'px'}}>
                                <HSort label={<b>Duration</b>} colName={'job.job2Duration'} state={myState}
                                       sortFunc={sortFunc}/>
                            </div>

                            {/* Reports */}
                            <div className={"setup-th " + borderLeft} style={{flexBasis: sizes[2] + 'px'}}>
                                <HSort label={<b>ESG checks</b>} colName={'job.job1ReportPublicationTimestampFmt'}
                                       state={myState}
                                       sortFunc={sortFunc} showLegend={true}/>
                            </div>
                            <div className={"setup-th " + borderLeft} style={{flexBasis: sizes[3] + 'px'}}>
                                <HSort label={<b>ESG reports</b>}
                                       colName={'job.job1GlobalReportPublicationTimestampFmt'} state={myState}
                                       sortFunc={sortFunc} showLegend={true}/>
                            </div>
                            <div className={"setup-th " + borderLeft} style={{flexBasis: sizes[2] + 'px'}}>
                                <HSort label={<b>Publish</b>} colName={'job.job1PublicationTimestampFmt'}
                                       state={myState}
                                       sortFunc={sortFunc} showLegend={true}/>
                            </div>
                            <div className={"setup-th " + borderLeft} style={{flexBasis: sizes[0] + 'px'}}><b>Review</b>
                            </div>
                            <div className={"setup-th " + borderLeft} style={{flexBasis: sizes[0] + 'px'}}>
                                <b>History</b></div>
                        </div>
                    </div>
                </div>
                {rows}
                <div style={{margin: '.75rem'}}>
                    {pageSelector}
                </div>
                <Modal
                    show={showActionModal}
                    onHide={() => hideActionModal()}
                    keyboard={true}
                    size={"lg"}
                    aria-labelledby="terms-and-conditions"
                    scrollable={true}
                >
                    <Modal.Header closeButton>{params}</Modal.Header>
                    <Modal.Body style={{margin: '0 1rem'}}>
                        <div className="folder">
                            {modalText}

                            {messages && (<div className="form-group">
                                <br/>
                                <div className={"alert import_log"}>
                                    {messages.map(message => {
                                        return <div className={"import_log_" + message.key}>{message.value}</div>;
                                    })}
                                </div>
                            </div>)}
                            {actionErrorMessage && <p>{actionErrorMessage}</p>}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => hideActionModal()}>
                            {messages ? 'Close' : 'Cancel'}
                        </Button>
                        {!messages && <Button variant="primary" onClick={() => callAction()}
                                              disabled={actionRequestStatus === 'pending'}>
                            {actionRequestStatus === 'pending' && (
                                <span className="spinner-border spinner-border-sm"/>)}
                            Apply
                        </Button>}
                    </Modal.Footer>
                </Modal>
            </>
            ;
            break;
        default:
            content = <div></div>;
    }
    return (
        <div className="dashboard">
            {content}
        </div>
    );
}
